import shiftHistoryUrl from './shift-history.html';
export default function shiftHistory() {
  return {
    restrict: 'E',
    templateUrl: shiftHistoryUrl,
    scope: {
      history: '=',
      historyMode: '=',
    },
    link($scope) {
      $scope.back = function back() {
        $scope.historyMode = false;
      };
    },
  };
}
